export default "__VITE_ASSET__BXDZIO25__"